import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";
import { useDataManColumn } from "../../hooks/useDataManColumn";
import { useDataMan } from "../../hooks/useDataMan";
import { DataManHierarchyHeaderColumnContent } from "../common/DataManHierarchyHeaderColumnContent";

export const DataManTableViewHierarchyColumnTitle: React.FC = () => {
  const { isActionColumn } = useDataManColumn();
  const { actionsColumnWidth } = useDataMan();

  const getWidthValue = () => {
    if (isActionColumn && actionsColumnWidth) {
      return typeof actionsColumnWidth === "number"
        ? `${actionsColumnWidth}px`
        : actionsColumnWidth;
    }
    return undefined;
  };

  const widthValue = getWidthValue();

  return (
    <th
      className={cn("border-b-0", isActionColumn && !widthValue && "w-32")}
      style={widthValue ? { width: widthValue, maxWidth: widthValue } : undefined}
    >
      <DataManHierarchyHeaderColumnContent />
    </th>
  );
};
